import { HttpClient } from 'api/http-client';
import {
  FinancialNotificationConfig,
  UpdateFinancialAlertPayload,
} from './types';

class FinancialNotificationsHttpClient extends HttpClient {
  public getFinancialNotificationConfig(): Promise<
    FinancialNotificationConfig[]
  > {
    return this.get('/account-notification-config');
  }

  public updateFinancialNotificationConfig(
    configId: number,
    payload: UpdateFinancialAlertPayload | FinancialNotificationConfig,
  ): Promise<FinancialNotificationConfig[]> {
    return this.put(`/account-notification-config/${configId}`, payload);
  }
}

export const FinancialNotificationsAPI = new FinancialNotificationsHttpClient();
